const routes = [
  {
    index: true,
    label: "Hyunsoo Park",
    path: "/",
  },
  {
    label: "Resume",
    path: "/resume",
  },
  {
    label: "Projects",
    path: "/projects",
  },
  {
    label: "Contact",
    path: "/contact",
  },
];

export default routes;
